import "./app-services/imports";
import "./index.css";
import React from "react";
import { createRoot } from "react-dom/client";
import Modal from "react-modal";
import { Provider } from "react-redux";
import storeSynchronize from "./app-services/lib/redux-localstore";
import store from "./app-services/store";
import AppLayout from "./AppLayout/AppLayout";
import ScreenSizeDetector from "./app-services/lib/screen-size-detector";
import reportWebVitals from "./reportWebVitals";
import messages from "./app-services/messages";
import Emitter from "./app-services/emiters";

// Tells react-modal which element to aria-hide behind an open modal —
// without it, every Modal instance warns on open (see ImageModal.js).
Modal.setAppElement("#root");

window.emit = new Emitter();
window.messages = messages;
window.screen = new ScreenSizeDetector();
const storeState = store();
storeSynchronize(storeState);

const routing = (
  <Provider store={storeState}>
    <AppLayout />
  </Provider>
);

const root = createRoot(document.getElementById("root"));
root.render(routing);
reportWebVitals();
